export { default } from './PLPView'
